import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/declaracaoSubstituicao/';

class DeclaracaoSubstituicao {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    findAllDeclaracoes(idContribuinte, ano, mes) {
        return axios.get(API_URL + 'allDeclaracoesSubstituicao?idContribuinte=' + idContribuinte + '&ano=' + ano + '&mes=' + mes, { headers: this.headers });
    }

    findAllDeclaracoesNumero(idContribuinte, ano, mes, numero, filtro) {
        return axios.get(API_URL + 'allDeclaracoesSubstituicaoNumero?idContribuinte=' + idContribuinte + '&ano=' + ano + '&mes=' + mes + '&numero=' + numero + '&filtro=' + filtro, { headers: this.headers });
    }

    findAllDeclaracoesPorPeriodo(idContribuinte, dataIni, dataFim) {
        return axios.get(API_URL + 'allDeclaracoesPorPeriodo?idContribuinte=' + idContribuinte + '&dataIni=' + dataIni + '&dataFim=' + dataFim, { headers: this.headers });
    }

    findAllDeclaracoesPorPeriodoNumero(idContribuinte, dataIni, dataFim, numero, filtro) {
        return axios.get(API_URL + 'allDeclaracoesPorPeriodoNumero?idContribuinte=' + idContribuinte + '&dataIni=' + dataIni + '&dataFim=' + dataFim + '&numero=' + numero + '&filtro=' + filtro, { headers: this.headers });
    }

    findAllDecAvulsa(idDeclaracao) {
        return axios.get(API_URL + 'allDecAvulsa?idDeclaracao=' + idDeclaracao, { headers: this.headers });
    }

    findAllNotasEmAberto(idContribuinte, ano, mes) {
        return axios.get(API_URL + 'allNotasFiscaisSubstituicao?idContribuinte=' + idContribuinte + '&ano=' + ano + '&mes=' + mes, { headers: this.headers });
    }

    findAllNotasEmAbertoPorPeriodo(idContribuinte, dataIni, dataFim) {
        return axios.get(API_URL + 'allNotasFiscaisEmAbertoPorPeriodo?idContribuinte=' + idContribuinte + '&dataIni=' + dataIni + '&dataFim=' + dataFim, { headers: this.headers });
    }

    findBoletos(id) {
        return axios.get(API_URL + 'allBoletos?idDeclaracao=' + id, { headers: this.headers });
    }

    declarar(idCliente, idUsuario, idContribuinte, ano, mes, tipo, notasFiscais) {
        return axios.post(API_URL + 'declaracaoSubstituicao?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&ano=' + ano + '&mes=' + mes + '&tipo=' + tipo, JSON.stringify(notasFiscais),
            { headers: this.headers });
    }

    gerarDam(idCliente, idUsuario, idContribuinte, ano, mes, tipo, notasFiscais) {
        return axios.post(API_URL + 'gerarDamSubstituicao?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&ano=' + ano + '&mes=' + mes + '&tipo=' + tipo, JSON.stringify(notasFiscais),
            { headers: this.headers });
    }

    editarDam(idUsuario, idDeclaracao, notasFiscais) {
        return axios.post(API_URL + 'editarDam?idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao, JSON.stringify(notasFiscais),
            { headers: this.headers });
    }

    declararParc(idCliente, idUsuario, idContribuinte, ano, mes, tipo, notasFiscais) {
        return axios.post(API_URL + 'declaracaoSubstituicaoParc?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&ano=' + ano + '&mes=' + mes + '&tipo=' + tipo, JSON.stringify(notasFiscais),
            { headers: this.headers });
    }

    declararSemMov(idCliente, idUsuario, idContribuinte, ano, mes) {
        return axios.post(API_URL + 'declaracaoSubstSemMov?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&ano=' + ano + '&mes=' + mes, null,
            { headers: this.headers });
    }

    cancelar(idUsuario, idContribuinte, idDeclaracao) {
        return axios.post(API_URL + 'cancelar?idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao, null,
            { headers: this.headers });
    }

    encerrar(idCliente, idUsuario, idContribuinte, idDeclaracao, vencimento) {
        return axios.post(API_URL + 'encerrarDeclaracao?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao + '&vencimento=' + vencimento, null,
            { headers: this.headers });
    }

    encerrarParc(idCliente, idUsuario, idContribuinte, idDeclaracao, vencimento) {
        return axios.post(API_URL + 'encerrarDeclaracaoParc?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao + '&vencimento=' + vencimento, null,
            { headers: this.headers });
    }

    retificar(idUsuario, idContribuinte, idCliente, idDeclaracao, notasFiscais) {
        return axios.post(API_URL + 'retificar?idUsuario=' + idUsuario + '&idContribuinte=' + idContribuinte + '&idCliente=' + idCliente + '&idDeclaracao=' + idDeclaracao, JSON.stringify(notasFiscais),
            { headers: this.headers });
    }

    carregarNotasDeclaracao(idDeclaracao) {
        return axios.get(API_URL + 'allNotasDeclaracao?idDeclaracao=' + idDeclaracao, { headers: this.headers });
    }

    atualizarVencimento(idDamAgrupamento, idDeclaracao, dataVencimento) {
        return axios.post(API_URL + 'atualizarVencimento?idDamAgrupamento=' + idDamAgrupamento + '&idDeclaracao=' + idDeclaracao + '&dataVencimento=' + dataVencimento, null, { headers: this.headers });
    }

    atualizarParcelaDam(tipoDam, idDamAgrupamento, idDeclaracao, dataVencimento, idUsuario) {
        console.log(tipoDam);
        return axios.post(API_URL + 'atualizarParcelaDam?idDamAgrupamento=' + idDamAgrupamento + '&idDeclaracao=' + idDeclaracao + '&dataVencimento=' + dataVencimento + '&idUsuario=' + idUsuario, null, { headers: this.headers });
    }

    criarPagamentoPix(idDamAgrupamento, idDeclaracao) {
        return axios.post(API_URL + 'criarPagamentoPix?idDamAgrupamento=' + idDamAgrupamento + '&idDeclaracao=' + idDeclaracao, null, { headers: this.headers });
    }

    criarPagamentoPixCp(idCalculoParcelado, idDeclaracao) {
        return axios.post(API_URL + 'criarPagamentoPixCp?idCalculoParcelado=' + idCalculoParcelado + '&idDeclaracao=' + idDeclaracao, null, { headers: this.headers });
    }

    consultarPagamentoPix(idDeclaracao, idDamAgrupamento) {
        return axios.get(API_URL + 'consultarPagamentoPix?idDeclaracao=' + idDeclaracao + '&idDamAgrupamento=' + idDamAgrupamento, { headers: this.headers });
    }

    competenciaEmFiscalizacao(idDeclaracao) {
        return axios.get(API_URL + 'competenciaEmFiscalizacao?idDeclaracao=' + idDeclaracao, { headers: this.headers });
    }

    competenciaDamEmFiscalizacao(idDeclaracao) {
        return axios.get(API_URL + 'competenciaDamEmFiscalizacao?idDeclaracao=' + idDeclaracao, { headers: this.headers });
    }

    carregarDadosCredito(idUsuario, idDeclaracao) {
        return axios.get(API_URL + 'carregarDadosCredito?idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao, { headers: this.headers });
    }

    aplicarCredito(idUsuario, idDeclaracao) {
        return axios.post(API_URL + 'aplicarCredito?idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao, null, { headers: this.headers });
    }

    transferirCalculosDeclaracao(idDeclaracaoOrigem, numeroDeclaracaoDestino) {
        return axios.post(API_URL + 'transferirCalculosDeclaracao?idDeclaracaoOrigem=' + idDeclaracaoOrigem + '&numeroDeclaracaoDestino=' + numeroDeclaracaoDestino, null, { headers: this.headers });
    }

    suspenderGuia(idUsuario, idDeclaracao) {
        return axios.post(API_URL + 'suspenderGuia?idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao, null, { headers: this.headers });
    }

    cancelarSuspencaoGuia(idUsuario, idDeclaracao) {
        return axios.post(API_URL + 'cancelarSuspencaoGuia?idUsuario=' + idUsuario + '&idDeclaracao=' + idDeclaracao, null, { headers: this.headers });
    }

    retencaoIndevida(idUsuario, motivoRetencaoIndevida, nota) {
        return axios.post(API_URL + 'retencaoIndevida?idUsuario=' + idUsuario + '&motivoRetencaoIndevida=' + motivoRetencaoIndevida, JSON.stringify(nota), { headers: this.headers });
    }

    getConsultaRelDamXls(dataIni, dataFim, numero, filtro) {
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'getConsultaDamSubRelatorioXls?idContribuinte=' + this.idContribuinte
            + '&dataIni=' + dataIni
            + '&dataFim=' + dataFim
            + '&numero=' + numero
            + '&filtro=' + filtro,
            { headers: this.headers });
    }

    getConsultaRelDecXlsComp(ano, mes, numero, filtro) {
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'getConsultaDecSubRelatorioXlsComp?idContribuinte=' + this.idContribuinte
            + '&ano=' + ano
            + '&mes=' + mes
            + '&numero=' + numero
            + '&filtro=' + filtro,
            { headers: this.headers });
    }
}

export default new DeclaracaoSubstituicao();